import './utils/consoleOverride'; // Suppress success console logs - must be first
import './utils/videojsWarnings'; // Suppress VideoJS deprecation warnings
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import "react-toastify/dist/ReactToastify.css";
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux';
import store from './redux/store'
import ReactGA from 'react-ga4';
import disableDevtool from 'disable-devtool';

// Disable devtools, context menu, and console logging only in production for real users.
// Do NOT activate in automated test environments (Playwright, Puppeteer, Selenium, CI).
const isAutomatedBrowser = typeof window !== 'undefined' && (
  Boolean(window.navigator?.webdriver) ||
  Boolean(window.__PLAYWRIGHT_TEST__) ||
  Boolean(window.Cypress)
);

const shouldDisableDevtool =
  process.env.REACT_APP_ENVIRONMENT === 'production' &&
  process.env.REACT_APP_DISABLE_DEVTOOL !== 'false' &&
  !isAutomatedBrowser;

if (shouldDisableDevtool) {
  // Option 5: Use disable-devtool NPM package
  disableDevtool({
    disableMenu: true,
    clearLog: true,
    ignore: () => Boolean(window.navigator?.webdriver || window.__PLAYWRIGHT_TEST__),
  });

  // Option 1 & 2: Disable Right-Click and Keyboard Shortcuts
  document.addEventListener('contextmenu', (e) => e.preventDefault());
  document.addEventListener('keydown', (e) => {
    if (e.key === 'F12') e.preventDefault();
    if ((e.ctrlKey && e.shiftKey && e.key === 'I') || (e.metaKey && e.altKey && e.key === 'I')) e.preventDefault();
    if ((e.ctrlKey && e.shiftKey && e.key === 'C') || (e.metaKey && e.altKey && e.key === 'C')) e.preventDefault();
    if ((e.ctrlKey && e.shiftKey && e.key === 'J') || (e.metaKey && e.altKey && e.key === 'J')) e.preventDefault();
    if ((e.ctrlKey && e.key === 'u') || (e.metaKey && e.key === 'u')) e.preventDefault();
  });

  // Option 4: Override console log
  console.log = () => {};
  console.info = () => {};
  console.warn = () => {};
  console.error = () => {};
  console.table = () => {};
}

// Global analytics enable switch
// Build-time default via REACT_APP_GA_ENABLED, runtime override via localStorage('GA_ENABLED')
let isGAEnabled = true;
try {
  const envEnabled = String(process.env.REACT_APP_GA_ENABLED ?? 'true').toLowerCase() === 'true';
  const ls = localStorage.getItem('GA_ENABLED'); // '0' disables, '1' enables
  isGAEnabled = ls == null ? envEnabled : ls === '1';
} catch {
  // Fallback to env only if localStorage access fails
  isGAEnabled = String(process.env.REACT_APP_GA_ENABLED ?? 'true').toLowerCase() === 'true';
}

if (!isGAEnabled) {
  // No-op GA methods when disabled
  try {
    ReactGA.send = () => { };
    ReactGA.event = () => { };
  } catch { }
}

const root = ReactDOM.createRoot(document.getElementById('root'));

// Initialize GA4 using env measurement ID; disable automatic first page_view (handled via router listener)
const GA_MEASUREMENT_ID = process.env.REACT_APP_GA_MEASUREMENT_ID;
if (isGAEnabled && GA_MEASUREMENT_ID) {
  ReactGA.initialize([
    { trackingId: GA_MEASUREMENT_ID, gtagOptions: { send_page_view: false } }
  ]);
} else {
  // Optional: keep initialized to avoid code paths assuming GA is set up
  try { ReactGA.initialize([]); } catch { }
  if (isGAEnabled && !GA_MEASUREMENT_ID) {
    // eslint-disable-next-line no-console
    console.warn('GA disabled: REACT_APP_GA_MEASUREMENT_ID not set');
  }
}

root.render(
  <Provider store={store}>
    <App />
  </Provider>
);

// Modified web vitals reporting to include GA
reportWebVitals(metric => {
  if (!isGAEnabled) return;
  ReactGA.event({
    category: 'Web Vitals',
    action: metric.name,
    value: Math.round(metric.value),
    label: metric.id,
    nonInteraction: true,
  });
});
